import React from "react";
import "./about.scss";

import logosumban from "../../Media/logo-green.png";

const aboutsumban = () => {
  return (
    <div id="about" className="about-sumban">
      <div className="containerlogo">
        <div className="logosumban">
          <img className="gambarsumban" src={logosumban} alt="logo sumban" />
        </div>
      </div>
      <div className="containerdesk">
        <div className="judul1">
          <h1>Jakarta Garden City, City Whithin a City</h1>
        </div>
        <div className="desk">
          Jakarta Garden City (JGC) adalah sebuah kawasan hunian terpadu yang
          berlokasi di Cakung, Jakarta Timur. Kawasan ini dikembangkan oleh PT
          Modernland Realty Tbk, dan dikenal sebagai salah satu proyek perumahan
          berskala besar yang mengusung konsep “kota di dalam kota” (city within
          a city). Jakarta Garden City dirancang sebagai kawasan yang menawarkan
          kehidupan modern dengan lingkungan hijau yang asri, fasilitas lengkap,
          dan infrastruktur yang mendukung kebutuhan masyarakat urban.
        </div>
      </div>
    </div>
  );
};

export default aboutsumban;
